var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header',{on:{"click-button":_vm.getData}}),(_vm.merchant.address)?_c('Form',{attrs:{"merchant":_vm.merchant}}):_vm._e(),(_vm.merchant.address)?_c('alerts',{attrs:{"items":_vm.items}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }